import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { UpdateOrderStatusEnum } from '../../../enums/updateOrderStatusEnum';
import { UpdateStatusText } from './ChemicalOrder.styles';
import { UpdateStatusIcon } from '../TankCleaningIcons.styles';

type Props = {
    updateOrderStatus: UpdateOrderStatusEnum;
    showIcon?: boolean;
    inList?: boolean;
    inTab?: boolean;
};

const UpdateOrderStatus: React.FC<Props> = (props) => {
    return (
        <>
            {props.updateOrderStatus === UpdateOrderStatusEnum.UpdatedByShip && !props.showIcon && (
                <span>
                    <UpdateStatusText className="status-update-ship">
                        <UpdateStatusIcon className="updated-by-ship">
                            <FontAwesomeIcon icon="exclamation-circle" title=" Order updated by ship" />
                        </UpdateStatusIcon>
                        Order updated by ship
                    </UpdateStatusText>
                </span>
            )}
            {props.updateOrderStatus === UpdateOrderStatusEnum.UpdatedByOperator && !props.showIcon && (
                <span>
                    <UpdateStatusText className="status-update-operator">
                        <UpdateStatusIcon className="updated-by-operator">
                            <FontAwesomeIcon icon="exclamation-circle" title="Order updated by operator" />
                        </UpdateStatusIcon>
                        Order updated by operator
                    </UpdateStatusText>
                </span>
            )}
            {props.updateOrderStatus === UpdateOrderStatusEnum.UpdatedByShip && props.showIcon && (
                <UpdateStatusIcon inList={props.inList} inTab={true} className="updated-by-ship">
                    <FontAwesomeIcon icon="exclamation-circle" title="Order updated by ship" />
                </UpdateStatusIcon>
            )}
            {props.updateOrderStatus === UpdateOrderStatusEnum.UpdatedByOperator && props.showIcon && (
                <UpdateStatusIcon inList={props.inList} inTab={true} className="updated-by-operator">
                    <FontAwesomeIcon icon="exclamation-circle" title="Order updated by operator" />
                </UpdateStatusIcon>
            )}
        </>
    );
};

export default UpdateOrderStatus;
